import React, { useEffect, useState } from "react";
import CText from "../../common/CText";
import { View, Text, Image, TouchableOpacity, Linking } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import MainContainer from "../../common/CWrapper";
import CHeader from "../../common/CHeader";
import CustomButton from "../../common/CustomButton";
import CDivider from "../../common/CDivider";
import { getEncryptKey, getPaymentData } from "../../api/apiManager";
import { Encryption as encrypt } from "../../utilities/Encryption";
import AsyncStorageFunc from "../../utilities/asyncStorage";
import ModalAlert from "../../common/ModalAlert";
import applicationStyles from "../../styles/applicationStyles";
import moment from "moment";
import { getConfigurations } from "../../api/serviceRequest"; 
export default function RechargeBreakup(props) {
  const styles = useStyles();
  const data = props.data;
  console.log("recharge data", data);
  const vrn = data?.vrn || 0;
  const amount = data?.rechargeAmount;
  const total =  data?.rechargeAmount; 
  const tagID = data?.tagID || "";
  const poolAcntNbr = data?.poolAcntNbr || "";
  const insuranceSkipped = data?.insuranceSkipped;
  const [HTMLDATA, setHTMLDATA] = useState("");
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
  };

  useEffect(()=>{
    loadDefaultConfig()
  },[])
  const loadDefaultConfig = () => {
    
    getConfigurations().then((res)=>{
      if(res.statusCode == 200) {

        const ccavenueAccessCode =res?.data.find((configItem) => configItem.key == "ccavenue_access_code_ff_portal");
        const CC_AVENUE_URL =res?.data.find((configItem) => configItem.key == "CC_AVENUE_URL");

        if (CC_AVENUE_URL) {
          global.CC_AVENUE_URL = CC_AVENUE_URL.value;
        }
        
        if (ccavenueAccessCode) {
          global.ccavenueAccessCode = ccavenueAccessCode.value;
        }
      }
    }).catch((err)=>{
      global.maxUploadFileSizeInMB = 2
      global.kycMaxUploadFileSizeInMB = 1
    })
}

  const rechargeButtonPressHandler = () => {
    let reqObj = {
      deviceId: "KA03MP1234",
    };
    getEncryptKey(reqObj)
      .then((encRes) => {
        encrypt(total + "", encRes.data).then((encAmount) => {
          let req = {
            useCase: tagID == "" ? "poolRecharge" : "RECHARGE",
            tagId: tagID,
            mobileNo: null,
            vehicleClass: "",
            amount: encAmount,
            poolId: tagID == "" ? poolAcntNbr : "",
            platform: "FF_PORTAL",
          };

          getPaymentData(req)
            .then((res) => {
              if (
                res.statusCode < 0 ||
                res.statusCode == 500 ||
                res.statusCode == 400 ||
                res.statusCode == -1017
              ) {
                setAlertModal({
                  title: "Error",
                  status: "error",
                  message: res.message,
                  navigateScreen: "",
                  actionButton: "OK",
                });
                setAlertModalVisible(true);
              } else {
                setHTMLDATA(res.response.paymentEncKey);

                AsyncStorageFunc.storeData("ORDERID", res.response.orderId);
                AsyncStorageFunc.storeData("TI_REQ", { isInsuranceSkipped: insuranceSkipped })
              }
            })
            .catch((err) => {
              setAlertModal({
                title: "Error",
                status: "error",
                message: err.message,
                navigateScreen: "",
                actionButton: "OK",
              });
              setAlertModalVisible(true);
            });
        });
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      });
  };

  return (
    <View style={styles.mainContainer}>
      <View style={styles.contentWrapper}>
        <View style={styles.contentLeft} >
          <CHeader
            onPress={props?.data?.fromScreen == "Recharge" ? () => props.setScreen("Recharge") : () => props.setScreen(props.info.backNavigation)}
            title="Back"
            navigation="Recharge"
          />
          <View style={{ width: "60%", marginLeft: 65, marginTop: 45 }}>
            <View>
              <CText.basicInformation>Recharge</CText.basicInformation>
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 45,
              }}
            >
              <CText.usedCarLoanUpto>Vehicle No.</CText.usedCarLoanUpto>
              <CText.backNavigationText>{vrn}</CText.backNavigationText>
            </View>
            <CDivider style={{ marginTop: 13 }} />
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 15,
              }}
            >
              <CText.usedCarLoanUpto>Recharge Amount</CText.usedCarLoanUpto>
              <CText.backNavigationText>₹ {amount} </CText.backNavigationText>
            </View>
            
            <CDivider style={{ marginTop: 13 }} />
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: 13,
              }}
            >
              <CText.basicInformation>Total Payable</CText.basicInformation>
              <CText.basicInformation>₹ {total}</CText.basicInformation>
            </View>
          </View>
          <View style={styles.footer}>
            <CustomButton
              text="Proceed"
              onPress={() => rechargeButtonPressHandler()}
            />
          </View>
        </View>
        <View style={styles.contentRight}>
          <TouchableOpacity
          style={styles.imgBanner}
          onPress={() => Linking.openURL(global?.AUTO_RECHARGE_APPLY_LINK)}>
            <Image
              style={styles.imgBanner}
              source={require("../../assets/images/credit_banner.png")}
            />
          </TouchableOpacity>
        </View>
       

      </View>
      {alertModalVisible && (
        <View style={[styles.overlayViewStyle,{position:'absolute'}]}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      )}
      {HTMLDATA && HTMLDATA != "" ? (
        <View style={[styles.overlayViewStyle,{position:'absolute'}]}>
          <View style={styles.overlay}>
            <View
              style={{
                backgroundColor: "white",
                width: 323,
                height: 200,
                borderRadius: 20,
                justifyContent: "flex-start",
                alignItems: "center",
                shadowColor: "rgba(0,0,0,0.05)",
                shadowOpacity: 1.5,
                elevation: 12,
                shadowRadius: 20,
                shadowOffset: { width: 1, height: 13 },
              }}
            >
              <Image source={require("../../assets/images/ic_success_ccavenue.png")} style={applicationStyles.iconSuccesIinlineModal} />
              <Text style={[applicationStyles.titleIinlineModal,{ paddingHorizontal: 30, textAlign: "center" }]}>
                {'You will be redirected to payment gateway Click OK to proceed'}
              </Text>
              <View style={styles.popupFooter}>
                <TouchableOpacity
                  onPress={() => {
                    setHTMLDATA("")
                    Linking.openURL(`${global.CC_AVENUE_URL}${HTMLDATA}&access_code=${ global.ccavenueAccessCode}`);
                  }}
                  style={applicationStyles.footerBtnIinlineModal}
                >
                  <Text style={applicationStyles.footerLinkIinlineModal}> OK</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      ):null}
    </View>
  );
}
const useStyles = CreateResponsiveStyle(
  {
    mainContainer : {
      height: 450,
      marginLeft: 20,
      marginTop : 20,
      borderRadius: 12,
      width: "100%",
  },
    contentWrapper: {
      height: 430,
      width: 1004,
      margin: 20,
      flexDirection: "row",
      gap: 20,
    },
    contentRight:{ width: "35%" },
    contentLeft:{
      width: "65%",
      backgroundColor: "#f6f6f6",
      borderRadius: 12,
      height: "100%",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
      alignItems: "center",
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    footer: {
      flexDirection: "row",
      alignSelf: "flex-end",
      width: 176,
      height: 44,
      marginTop: 50,
      marginRight: 32,
    },
    popupFooter: {
      width: "100%",
      bottom: 0,
      paddingVertical: 10,
      alignItems: "center",
    },
    imgBanner:{ 
      height: "100%", 
      width: "100%", 
      borderRadius: 12
     }
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      mainContainer :{
        marginLeft: 10,
        width:'95%'
    },
      contentWrapper:{
        width:'100%',
        flexDirection:'column',
        marginLeft:5
      },
      contentLeft:{
        width:'100%'
      },
      contentRight:{
        width:'100%'
      },
      imgBanner:{ 
        height: 300, 
        width: 300,
        alignSelf:'center'
       },
    
    },
    [DEVICE_SIZES.XS]: {
      mainContainer :{
        marginLeft: 10,
        width:'95%'
    },
      contentWrapper:{
        width:'100%',
        flexDirection:'column',
        marginLeft:5
      },
      contentLeft:{
        width:'100%'
      },
      contentRight:{
        width:'100%'
      },
      imgBanner:{ 
        height: 300, 
        width: 300,
        alignSelf:'center'
       },
    },
  }
);
